import { noop } from "../../utils/noop";
import { useIsomorphicLayoutEffect } from "../useIsomorphicLayoutEffect";
/**
 * Lock body scrolling on mount.
 */

export function useBodyScrollLock() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled;

  useIsomorphicLayoutEffect(function () {
    if (enabled) {
      var originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      return function () {
        document.body.style.overflow = originalStyle;
      };
    }

    return noop;
  }, [enabled]);
}